import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface Props {
  onConfirm(): void
}

export const SubscriptionCQGConfirmationModal: BaseModalType<Props> = ({ onConfirm, close }) => {
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('Subscriptions.CQG Integrated Client')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t('Subscriptions.By subscribing to CQG Integrated Client you confirm')}
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary
          onClick={() => {
            onConfirm()
            close()
          }}
        >
          {t('Confirm')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
